import React, { useEffect, useState } from 'react'
import { Button, Table, Typography, Space, Image, Switch, Flex, Form, Row, Col } from 'antd'
import { serviceData } from '../../Data';
import { ActionButton, AddServiceDrawer, AlertModal, SearchInput } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../shared';
import { apiCalls } from '../../shared/Apis';

let timer;
const { Text } = Typography;
const ServiceTable = ({setVisible,visible}) => {

    const [deleteitem,setDeleteItem] = useState(false)
    const [edititem,setEditItem] = useState(false)
    const [deletionLoading, setDeletionLoading]= useState(false)
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const { serviceData, loadingservice, filters, pagination } = useSelector(state => state?.ServiceApi)

    useEffect(()=>{
        dispatch(actionsApi.getServiceApi({...filters, ...pagination, pageNo: 1}))
        form.setFieldsValue({
            ...filters,
        })
    },[])

    const call = (pageNo = 1, pageSize = 10) => {
        dispatch(actionsApi?.getServiceApi({ ...filters, pageNo, pageSize }))
    }

    function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getServiceApi({ ...filters, name, pageNo, pageSize }))
    }
    
        function debounce(func, delay) {
            return function(...args) {
                clearTimeout(timer)
                timer = setTimeout(() => {
                    func.apply(this, args)
                }, delay)
            };
        }
        const debouncedSearchHandler = debounce(searchHandler, 400)
    
        const onChange = (checked, row) => {
            const newStatus = checked ? 1 : 2;
            dispatch(actionsApi?.servicestatusResponse({ id: row.id, status: newStatus }));
            dispatch(actionsApi?.updateServiceStatus({ id: row.id, status: newStatus }));
        };

    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Service Name</Text>,
            dataIndex: 'name',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (status) => {
                return (
                    status === 1 ? (
                        <Text className='active fs-12 badge-cs'>Active</Text>
                    ) : (
                        <Text className='inactive fs-12 badge-cs'>Inactive</Text>
                    )
                );
            },
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <Switch size='small' defaultChecked 
                        checked={row?.status === 1}
                        onChange={(checked) => onChange(checked, row)}
                    />
                    <ActionButton
                        title='Edit Service'
                        shape="circle"
                        icon={<Image src='/assets/icons/edit.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setVisible(true);setEditItem(row)}}
                    />
                    <ActionButton
                        title='Delete Service'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name: row?.name, id:row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    const DeleteService= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.addServiceapi?.DeleteService(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }


    return (
        <Flex vertical gap={20}>
            
            <Form
                form={form}
                layout="vertical"
            >
                <Row gutter={[16,16]} align={'middle'}>
                    <Col lg={8} md={12} sm={24} xs={24}>
                        <SearchInput 
                            name='name'
                            placeholder='Search'
                            prefix={<img src='/assets/icons/search.png' width={20} />}
                            className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                            onChange={(e)=>debouncedSearchHandler(e.target.value, 1, 20)}
                        />
                    </Col>
                </Row>
            </Form>
            <Table
                size='large'
                columns={columns}
                dataSource={serviceData}
                className='pagination'
                showSorterTooltip={false}
                scroll={{ x: 800 }}
                pagination={{
                    hideOnSinglePage: true,
                    total: pagination?.totalRecords,
                    pageSize: pagination?.pageSize,
                    defaultPageSize: pagination?.pageSize,
                    current: pagination?.pageNo,
                    size: "default",
                    pageSizeOptions: ['10', '20', '50', '100'],
                    onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                    showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
                }}
                loading = {
                    {
                        ...TableLoader,
                        spinning: loadingservice
                    }
                }
            />
            <AlertModal
                visible={deleteitem}
                deleteitem={deleteitem}
                deletionLoading={deletionLoading}
                callBack={DeleteService}
                onClose={()=>{setDeleteItem(false)}}
            />
            <AddServiceDrawer 
                visible={visible}
                edititem={edititem}
                getServiceApi={call}
                onClose={()=>{setVisible(false);setEditItem(null)}}
            />
        </Flex>
    )
}

export { ServiceTable }